import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../_css/AIFeedback.css";
import { groupByGradeAndExam } from "../../requests";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { useDispatch } from "react-redux";
import SearchableDropdown from "../common/SearchableDropdown";

const Index = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [filterGrade, setFilterGrade] = useState("");
  const [filterExam, setFilterExam] = useState("");
  const [gradeOptions, setGradeOptions] = useState([]);
  const [examOptions, setExamOptions] = useState([]);

  const goStudents = (row) => {
    const q = new URLSearchParams({
      grade: String(row.grade ?? ""),
      exam: String(row.exam_name ?? ""),
    });
    navigate(`/ai-feedback/students?${q.toString()}`);
  };

  const fetchData = async () => {
    dispatch(startLoader());
    try {
      const params = { page, limit };
      if (filterGrade !== "" && filterGrade != null) {
        params.grade = String(filterGrade);
      }
      if (filterExam && filterExam !== "All Exams") {
        params.exam = filterExam;
      }
      const res = await groupByGradeAndExam(params);
      const payload = res?.data;
      setRows(Array.isArray(payload?.data) ? payload.data : []);
      setTotalCount(Number(payload?.totalCount) || 0);
      setGradeOptions(
        Array.isArray(payload?.grades) ? payload.grades.map(String) : []
      );
      setExamOptions(
        Array.isArray(payload?.exams) ? payload.exams.map(String) : []
      );
    } catch (error) {
      console.log(error);
      setRows([]);
      setTotalCount(0);
      setGradeOptions([]);
      setExamOptions([]);
    } finally {
      dispatch(stopLoader());
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, limit, filterGrade, filterExam]);

  return (
    <div className="ai-fd-main">
      <div className="ai-fd-con">
        <div className="ai-fd-head">
          <div className="ai-fd-head-text">AI Feedback</div>
          <div className="ai-fd-right" style={{ alignItems: "end" }}>
            <div style={{ width: "110px" }}>
              <label className="pdf-input-label">Grade</label>
              <SearchableDropdown
                options={["All classes", ...gradeOptions]}
                selected={filterGrade}
                setSelected={(v) => {
                  setFilterGrade(v);
                  setPage(1);
                }}
                allowManualEntry={false}
                color="#E5E7EB"
                placeHolder="All grades"
              />
            </div>
            <div style={{ minWidth: "180px" }}>
              <label className="pdf-input-label">Exam</label>
              <SearchableDropdown
                options={["All Exams", ...examOptions]}
                selected={filterExam}
                setSelected={(v) => {
                  setFilterExam(v === "All Exams" ? "" : v);
                  setPage(1);
                }}
                allowManualEntry={true}
                color="#E5E7EB"
                placeHolder="Select or type exam"
              />
            </div>
          </div>
        </div>

        <div className="ai-fb-table ai-fb-table-simple">
          <div className="ai-fb-table-head">
            <div className="ai-fb-head-cell" style={{ width: "8%" }}>
              S.No
            </div>
            <div className="ai-fb-head-cell" style={{ width: "32%" }}>
              Exam
            </div>
            <div className="ai-fb-head-cell" style={{ width: "14%" }}>
              Grade
            </div>
            <div
              className="ai-fb-head-cell ai-fb-cell-center"
              style={{ width: "14%" }}
            >
              Total students
            </div>
            <div
              className="ai-fb-head-cell ai-fb-cell-center"
              style={{ width: "32%" }}
            >
              Action
            </div>
          </div>

          {rows.length === 0 && (
            <div className="ai-fb-empty">No grade / exam groups yet.</div>
          )}

          {rows.map((row, index) => (
            <div
              key={`${row.grade}-${row.exam_name}-${index}`}
              className="ai-fb-group"
            >
              <div className="ai-fb-main-row">
                <div className="ai-fb-row-cell" style={{ width: "8%" }}>
                  {(page - 1) * limit + index + 1}
                </div>
                <div
                  className="ai-fb-row-cell ai-fb-test-name"
                  style={{ width: "32%" }}
                >
                  {row.exam_name}
                </div>
                <div className="ai-fb-row-cell" style={{ width: "14%" }}>
                  {row.grade}
                </div>
                <div
                  className="ai-fb-row-cell ai-fb-cell-center"
                  style={{ width: "14%" }}
                >
                  {row.total_students}
                </div>
                <div
                  className="ai-fb-row-cell ai-fb-view-all-cell ai-fb-cell-center"
                  style={{ width: "32%" }}
                >
                  <button
                    type="button"
                    className="ai-fb-view-all-btn"
                    onClick={() => goStudents(row)}
                  >
                    View students
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div
          className="di-flex"
          style={{
            width: "100%",
            marginTop: 16,
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <div style={{ color: "#6B7280" }}>
            Showing {(page - 1) * limit + 1} to{" "}
            {rows.length + (page - 1) * limit} out of {totalCount} items
          </div>
          <div
            className="di-flex"
            style={{ justifyContent: "end", gap: "10px" }}
          >
            <button
              disabled={page === 1}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity: page === 1 ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
            >
              Previous
            </button>
            <button
              disabled={rows.length + (page - 1) * limit >= totalCount}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity:
                  rows.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (rows.length ? p + 1 : p))}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
